import React from 'react';

import { IUserInterfaceMetadataContext, UserInterfaceMetadataContext } from '../Contexts/UserInterfaceMetadataContext';

export default function useUserInterfaceMetadata(): IUserInterfaceMetadataContext {
	const context = React.useContext(UserInterfaceMetadataContext);
	if (!context) {
		throw new Error('useUserInterfaceMetadata must be used within a UserInterfaceMetadataProvider');
	}
	return context;
}
